function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 10v4M18 8v8",
  stroke: "currentcolor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.875 8.625H3.5a1 1 0 00-1 1v4.75a1 1 0 001 1h2.375l3.979 3.371a1 1 0 001.646-.763V6.017c0-.852-.997-1.314-1.646-.763l-3.98 3.371z",
  stroke: "currentcolor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));